import { combineReducers } from 'redux';
import { formReducer } from './form';
import dirty from './dirty';

export default combineReducers({
  form: formReducer,
  dirty,
});



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step4/reducers/index.js